document.addEventListener('DOMContentLoaded', function() {
    var trigger = document.getElementById('feel-it-trigger');
    var overlay = document.getElementById('feel-it-overlay');
    var closeBtn = document.getElementById('feel-it-close');

    if (!trigger || !overlay) return;

    function openModal() {
        overlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        setTimeout(function() {
            overlay.classList.add('feel-it-overlay--active');
        }, 10);
    }

    function closeModal() {
        overlay.classList.remove('feel-it-overlay--active');
        setTimeout(function() {
            overlay.style.display = 'none';
            document.body.style.overflow = '';
        }, 300);
    }

    trigger.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && overlay.style.display === 'flex') closeModal();
    });
});
